import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-navy-900 text-white relative overflow-hidden" data-id="element-22">
      {/* Background accents */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" data-id="element-23"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" data-id="element-24"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-26">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-27">
            Conversemos sobre cómo optimizar tu inversión publicitaria
          </h2>
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-28">
            Sin compromiso. Sin promesas exageradas. Solo una conversación
            profesional sobre tus objetivos.
          </p>
          <a href="https://calendly.com/gooutperformance/30min" target="_blank" rel="noopener noreferrer" className="bg-white text-navy-900 hover:bg-blue-50 px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-lg hover:shadow-xl inline-flex items-center group" data-id="element-29">
            Agendar reunión
            <ArrowRight className="ml-2 h-5 w-5 text-blue-600 group-hover:translate-x-1 transition-transform" data-id="element-30" />
          </a>
        </motion.div>
      </div>
    </section>;
}